import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Seo from "@/components/Seo";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Chapters, { Chapter04 } from "@/components/Chapters";
import Services from "@/components/Services";
import HowItWorks from "@/components/HowItWorks";
import Outcomes from "@/components/Outcomes";
import WhoWeWorkWith from "@/components/WhoWeWorkWith";
import NotFor from "@/components/NotFor";
import Values from "@/components/Values";
import Standards from "@/components/Standards";
import Faq from "@/components/Faq";
import CtaSection from "@/components/CtaSection";
import ContactModal from "@/components/ContactModal";
import Footer from "@/components/Footer";

function App() {
  const [contactOpen, setContactOpen] = useState(false);
  const openContact = () => setContactOpen(true);

  useEffect(() => {
    const lenis = new Lenis({ duration: 0.85, anchors: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-[#fbfbfd] text-[#1d1d1f] min-h-screen" id="top">
      <Seo
        title="VONTRAIL GROWTH — Content, handled."
        siteName="VONTRAIL GROWTH"
        description="VONTRAIL GROWTH is a premium content growth partner for creators, founders, experts and businesses. Strategy, research, scripting, editing, thumbnails, titles — from idea to upload."
        image="/vontrail-logo.png"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "VONTRAIL GROWTH",
          description:
            "Premium content growth partner handling strategy, research, scripting, editing, thumbnails, titles and ongoing optimization for creators, founders and businesses.",
        }}
      />
      <Header onContact={openContact} />
      <main>
        <Hero onContact={openContact} />
        <Chapters />
        <Services />
        <HowItWorks />
        <Chapter04 />
        <Outcomes />
        <WhoWeWorkWith />
        <NotFor />
        <Values />
        <Standards />
        <Faq onContact={openContact} />
        <CtaSection onContact={openContact} />
      </main>
      <Footer />
      <ContactModal open={contactOpen} onClose={() => setContactOpen(false)} />
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
